import { render, staticRenderFns } from "./PsCriteriaControl.vue?vue&type=template&id=951167d8&scoped=true&"
import script from "./PsCriteriaControl.vue?vue&type=script&lang=js&"
export * from "./PsCriteriaControl.vue?vue&type=script&lang=js&"
import style0 from "./PsCriteriaControl.vue?vue&type=style&index=0&id=951167d8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "951167d8",
  null
  
)

export default component.exports